export default __webpack_public_path__ + "static/media/news22.25ae9f9c.jpg";